import { render, staticRenderFns } from "./SidebarNavItemIS.vue?vue&type=template&id=0c564a85"
import script from "./SidebarNavItemIS.vue?vue&type=script&lang=js"
export * from "./SidebarNavItemIS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports